<ion-item [class.hide-label]="hideLabel">
  <ion-icon [name]="select.icon" slot="start" size="large"></ion-icon>
  <ion-label [class.ion-hide]="hideLabel"><span [translate]="select.text"></span></ion-label>
  <destination-selection-tool [tool]="select"></destination-selection-tool>
</ion-item>
